var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.8,
    height: 37.8,
    viewBox: "0 0 92.8 37.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-car-dashboard-710605",
    transform: "translate(-3.6 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8380",
    "data-name": "Group 8380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9599",
    "data-name": "Path 9599",
    d: "M13.9,68.8c-3.4,0-5.8-.4-7.5-1.4A5.718,5.718,0,0,1,3.6,62C3.6,49.8,24.4,31,50,31S96.4,49.7,96.4,62c0,6-5.2,6.8-10.2,6.8a124.31,124.31,0,0,1-13.3-1.1A199.488,199.488,0,0,0,50,66.5a220.966,220.966,0,0,0-22.7,1.2,125.933,125.933,0,0,1-13.4,1.1ZM50.1,33.7c-25.4,0-46,16.2-46,28.3,0,2.4.8,4,2.5,5,1.6.9,3.9,1.3,7.2,1.3h0a126.377,126.377,0,0,0,13.3-1.1A194.349,194.349,0,0,1,50,65.6a218.455,218.455,0,0,1,22.9,1.6,124.309,124.309,0,0,0,13.3,1.1c6.9,0,9.8-1.8,9.8-6.4C96.1,49.9,75.5,33.7,50.1,33.7Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3808",
    "data-name": "Rectangle 3808",
    width: 17,
    height: 15.6,
    transform: "translate(41.6 47.4)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8381",
    "data-name": "Group 8381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9600",
    "data-name": "Path 9600",
    d: "M73,66.6A13.1,13.1,0,1,1,86.1,53.5,13.145,13.145,0,0,1,73,66.6Zm0-24.9A11.7,11.7,0,1,0,84.7,53.5,11.715,11.715,0,0,0,73,41.7Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8382",
    "data-name": "Group 8382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9601",
    "data-name": "Path 9601",
    d: "M73,65A11.5,11.5,0,1,1,84.5,53.5,11.5,11.5,0,0,1,73,65Zm0-22.6A11.1,11.1,0,1,0,84.1,53.5,11.139,11.139,0,0,0,73,42.4Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8384",
    "data-name": "Group 8384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8383",
    "data-name": "Group 8383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9602",
    "data-name": "Path 9602",
    d: "M73,57.4a3.9,3.9,0,0,1-3.9-3.9A3.842,3.842,0,0,1,73,49.6a3.9,3.9,0,0,1,0,7.8Zm0-6.9a3,3,0,1,0,3,3A3.076,3.076,0,0,0,73,50.5Z",
    fill: "#253845"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8385",
    "data-name": "Group 8385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9603",
    "data-name": "Path 9603",
    d: "M66.5,46.8l3.1,3.6.9-.9Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8386",
    "data-name": "Group 8386"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3809",
    "data-name": "Rectangle 3809",
    width: 0.4,
    height: 1,
    transform: "translate(72.8 42.2)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8387",
    "data-name": "Group 8387"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3810",
    "data-name": "Rectangle 3810",
    width: 1,
    height: 0.4,
    transform: "translate(61.7 53.3)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8388",
    "data-name": "Group 8388"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3811",
    "data-name": "Rectangle 3811",
    width: 1,
    height: 0.4,
    transform: "translate(83.3 53.4)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8389",
    "data-name": "Group 8389"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3812",
    "data-name": "Rectangle 3812",
    width: 0.4,
    height: 1,
    transform: "translate(64.883 45.576) rotate(-45)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8390",
    "data-name": "Group 8390"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3813",
    "data-name": "Rectangle 3813",
    width: 0.4,
    height: 1,
    transform: "matrix(0.708, -0.706, 0.706, 0.708, 80.117, 60.936)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8391",
    "data-name": "Group 8391"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3814",
    "data-name": "Rectangle 3814",
    width: 1,
    height: 0.4,
    transform: "translate(64.892 61.298) rotate(-45)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8392",
    "data-name": "Group 8392"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3815",
    "data-name": "Rectangle 3815",
    width: 1,
    height: 0.4,
    transform: "translate(80.168 46.099) rotate(-45)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8393",
    "data-name": "Group 8393"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3816",
    "data-name": "Rectangle 3816",
    width: 0.4,
    height: 1,
    transform: "translate(68.744 43.025) rotate(-20.965)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8394",
    "data-name": "Group 8394"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3817",
    "data-name": "Rectangle 3817",
    width: 1,
    height: 0.4,
    transform: "matrix(0.933, -0.359, 0.359, 0.933, 62.437, 57.272)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8395",
    "data-name": "Group 8395"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3818",
    "data-name": "Rectangle 3818",
    width: 1,
    height: 0.4,
    transform: "translate(82.548 49.685) rotate(-20.942)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8396",
    "data-name": "Group 8396"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3819",
    "data-name": "Rectangle 3819",
    width: 0.4,
    height: 1,
    transform: "matrix(0.406, -0.914, 0.914, 0.406, 62.622, 49.079)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8397",
    "data-name": "Group 8397"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3820",
    "data-name": "Rectangle 3820",
    width: 0.4,
    height: 1,
    transform: "translate(82.397 57.84) rotate(-65.947)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8398",
    "data-name": "Group 8398"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3821",
    "data-name": "Rectangle 3821",
    width: 1,
    height: 0.4,
    transform: "translate(77.092 44.026) rotate(-66.06)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8400",
    "data-name": "Group 8400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8399",
    "data-name": "Group 8399"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(70.5 51)",
    fill: "#253845"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8401",
    "data-name": "Group 8401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9604",
    "data-name": "Path 9604",
    d: "M27.5,66.6A13.1,13.1,0,1,1,40.6,53.5,13.145,13.145,0,0,1,27.5,66.6Zm0-24.9A11.7,11.7,0,1,0,39.2,53.4,11.715,11.715,0,0,0,27.5,41.7Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8402",
    "data-name": "Group 8402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9605",
    "data-name": "Path 9605",
    d: "M27.5,65A11.5,11.5,0,1,1,39,53.5,11.5,11.5,0,0,1,27.5,65Zm0-22.6A11.1,11.1,0,1,0,38.6,53.5,11.139,11.139,0,0,0,27.5,42.4Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8404",
    "data-name": "Group 8404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8403",
    "data-name": "Group 8403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9606",
    "data-name": "Path 9606",
    d: "M27.5,57.4a3.9,3.9,0,0,1-3.9-3.9,3.842,3.842,0,0,1,3.9-3.9,3.9,3.9,0,0,1,0,7.8Zm0-6.9a3,3,0,1,0,3,3A3.148,3.148,0,0,0,27.5,50.5Z",
    fill: "#253845"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8405",
    "data-name": "Group 8405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9607",
    "data-name": "Path 9607",
    d: "M27.4,44.3,26.8,49h1.3Z",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8406",
    "data-name": "Group 8406"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3822",
    "data-name": "Rectangle 3822",
    width: 0.8,
    height: 1.3,
    transform: "translate(27.1 42.2)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8407",
    "data-name": "Group 8407"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3823",
    "data-name": "Rectangle 3823",
    width: 1.3,
    height: 0.8,
    transform: "translate(16.2 53.1)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8408",
    "data-name": "Group 8408"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3824",
    "data-name": "Rectangle 3824",
    width: 1.3,
    height: 0.8,
    transform: "translate(37.4 53.1)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8409",
    "data-name": "Group 8409"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3825",
    "data-name": "Rectangle 3825",
    width: 0.8,
    height: 1.3,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 19.213, 45.777)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8410",
    "data-name": "Group 8410"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3826",
    "data-name": "Rectangle 3826",
    width: 0.8,
    height: 1.3,
    transform: "translate(34.153 60.821) rotate(-45)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8411",
    "data-name": "Group 8411"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3827",
    "data-name": "Rectangle 3827",
    width: 1.3,
    height: 0.8,
    transform: "translate(19.232 61.195) rotate(-45.049)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8412",
    "data-name": "Group 8412"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3828",
    "data-name": "Rectangle 3828",
    width: 1.3,
    height: 0.8,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 34.205, 46.184)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8413",
    "data-name": "Group 8413"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3829",
    "data-name": "Rectangle 3829",
    width: 0.4,
    height: 1,
    transform: "translate(27.3 42.2)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8414",
    "data-name": "Group 8414"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3830",
    "data-name": "Rectangle 3830",
    width: 1,
    height: 0.4,
    transform: "translate(16.2 53.3)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8415",
    "data-name": "Group 8415"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3831",
    "data-name": "Rectangle 3831",
    width: 1,
    height: 0.4,
    transform: "translate(37.8 53.4)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8416",
    "data-name": "Group 8416"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3832",
    "data-name": "Rectangle 3832",
    width: 0.4,
    height: 1,
    transform: "translate(19.307 45.632) rotate(-45)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8417",
    "data-name": "Group 8417"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3833",
    "data-name": "Rectangle 3833",
    width: 0.4,
    height: 1,
    transform: "matrix(0.708, -0.706, 0.706, 0.708, 34.612, 60.921)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8418",
    "data-name": "Group 8418"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3834",
    "data-name": "Rectangle 3834",
    width: 1,
    height: 0.4,
    transform: "translate(19.393 61.285) rotate(-44.955)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8419",
    "data-name": "Group 8419"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3835",
    "data-name": "Rectangle 3835",
    width: 1,
    height: 0.4,
    transform: "translate(34.663 46.084) rotate(-45)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8420",
    "data-name": "Group 8420"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3836",
    "data-name": "Rectangle 3836",
    width: 0.4,
    height: 1,
    transform: "translate(23.243 43.018) rotate(-20.965)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8421",
    "data-name": "Group 8421"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3837",
    "data-name": "Rectangle 3837",
    width: 1,
    height: 0.4,
    transform: "translate(16.843 57.299) rotate(-21.07)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8422",
    "data-name": "Group 8422"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3838",
    "data-name": "Rectangle 3838",
    width: 1,
    height: 0.4,
    transform: "translate(37.049 49.676) rotate(-20.942)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8423",
    "data-name": "Group 8423"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3839",
    "data-name": "Rectangle 3839",
    width: 0.4,
    height: 1,
    transform: "matrix(0.406, -0.914, 0.914, 0.406, 17.112, 49.061)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8424",
    "data-name": "Group 8424"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3840",
    "data-name": "Rectangle 3840",
    width: 0.4,
    height: 1,
    transform: "matrix(0.408, -0.913, 0.913, 0.408, 36.842, 57.912)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8425",
    "data-name": "Group 8425"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3841",
    "data-name": "Rectangle 3841",
    width: 1,
    height: 0.4,
    transform: "translate(31.541 44.096) rotate(-66.034)",
    fill: "#253845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8427",
    "data-name": "Group 8427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8426",
    "data-name": "Group 8426"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(25 51)",
    fill: "#253845"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3842",
    "data-name": "Rectangle 3842",
    width: 7.3,
    height: 1.2,
    transform: "translate(46.5 43.1)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9608",
    "data-name": "Path 9608",
    d: "M46.5,37.7H41.1v1.2H59.2V37.7H46.5Z",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3843",
    "data-name": "Rectangle 3843",
    width: 13.3,
    height: 1.2,
    transform: "translate(43.5 40.4)",
    fill: "#253845"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDashboardIcon);
export default __webpack_public_path__ + "static/media/car-dashboard-icon.f5f33de7578005bbeee1e0e9b7d29deb.svg";
export { ForwardRef as ReactComponent };